let optionitem = document.querySelectorAll('.optionitem')
let onlyOption = document.querySelectorAll('.only')
let more_btn = document.querySelectorAll('.el-button')
let more_item = document.querySelectorAll('.is-close')

for(let i = 0 ; i < optionitem.length ; i++){
    optionitem[i].onclick = function (e) {

        if(i<onlyOption.length){
            for(let j=0;j<onlyOption.length;j++){
            optionitem[j].classList.remove('active')    
             }
        }       
        e.currentTarget.classList.add('active')
        if(e.currentTarget.children.length!=0){
            if(e.currentTarget.children[0].children[0].children[0].className.indexOf('icon-selected')>-1){
                e.currentTarget.children[0].children[0].children[0].classList.remove('icon-selected')
            }else{
                e.currentTarget.children[0].children[0].children[0].classList.add('icon-selected')
            }
        }
    }
}


for(let i=0 ; i < more_btn.length ; i++){
    more_btn[i].onclick = function(e){
        if(e.currentTarget.children[0].children[0].className.indexOf('is-open')<0){
            e.currentTarget.children[0].children[0].classList.add('is-open')
            more_item[i].classList.remove('is-close')
        }else{
            e.currentTarget.children[0].children[0].classList.remove('is-open')
            more_item[i].classList.add('is-close')
        }
    }
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

let dropdownCart = document.querySelector('#dropdown-cart')
let landingpageBtn = document.querySelectorAll('.landingpagebtn')

if (IsPC()) {
  	let timer = false
    for(let i=0; i<landingpageBtn.length ; i++){
        landingpageBtn[i].onclick=function(){

        dropdownCart.style.display='block'
        if(timer){
            clearTimeout(pagesTimer)
        }
            pagesTimer=setTimeout(()=>{
            dropdownCart.style.display='none'
            timer = true
            },5000)
	}}
} else {

    // 移动端监听点击购买按钮事件，点击之后显示提示框
    let printerPage = document.getElementById('3d-printer');
    let buyButton = printerPage && printerPage.getElementsByClassName('landingpagebtn-mobile')[0];
    let mobileBuyConfirm = document.getElementsByClassName('mobile-buy-now')[0];
    if(buyButton){
      buyButton.addEventListener('touchstart', function() {
        const BUY_CONFIRM_ANIMATION = 'mobile-buy-now-tip';  // 显示提示框动画的class
        let hasAnimationCls = mobileBuyConfirm.className.includes(BUY_CONFIRM_ANIMATION);

        // 如果提示框在显示，但是点击了多次购买按钮，不会显示多个提示框，还是保留上一次显示的那个
        if (hasAnimationCls) {
          mobileBuyConfirm.classList.remove(BUY_CONFIRM_ANIMATION);
        }

        // 必须要加个延时，否则先remove后add会无效
        setTimeout(function () {
          mobileBuyConfirm.classList.add(BUY_CONFIRM_ANIMATION);
        }, 10);
      });
    }
}
